import { render, staticRenderFns } from "./ContractRiskLevels.vue?vue&type=template&id=30ee972d&"
import script from "./ContractRiskLevels.vue?vue&type=script&lang=js&"
export * from "./ContractRiskLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports